import { useEffect, useRef } from 'react'

export const useInputRefForFocus = () => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.code === 'KeyK') {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()

        if (inputRef.current) {
          inputRef.current.focus()

          inputRef.current.select()
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown, { capture: true })

    return () =>
      window.removeEventListener('keydown', handleKeyDown, { capture: true })
  }, [])

  return { inputRef }
}
